import { StatusBadgeItemColorType } from "@revmatics/catalyst";

const fitData: { [key: string]: string } = {
  high: "Core",
  medium: "Adjacent",
  low: "Expansion",
};
const fitColorData: { [key: string]: StatusBadgeItemColorType } = {
  core: "success",
  adjacent: "info",
  expansion: "warning",
};

export const getFitColor = (key: string) => {
  return fitColorData[key];
};

export const getFitName = (key: string) => {
  return fitData[key] || key;
};

export const getFitNameByNumber = (value: number) => {
  if (value < 40) {
    return fitData.low;
  } else if (value < 70) {
    return fitData.medium;
  } else {
    return fitData.high;
  }
};
